// ** React Imports
import React, { Fragment, useState, useEffect, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Stepper from '@mui/material/Stepper'
import MenuItem from '@mui/material/MenuItem'
import Checkbox from '@mui/material/Checkbox'
import ListItemText from '@mui/material/ListItemText'
import StepLabel from '@mui/material/StepLabel'
import Typography from '@mui/material/Typography'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton'
import CardContent from '@mui/material/CardContent'
import { styled } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import MuiStep from '@mui/material/Step'
import InputAdornment from '@mui/material/InputAdornment'
import IgnoreIcon from '@mui/icons-material/VisibilityOff'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CardHeader from '@mui/material/CardHeader'
import { DataGrid } from '@mui/x-data-grid'
import { DataGridPro } from '@mui/x-data-grid-pro';
import {TextField, Select, FormControl, InputLabel } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import ListSubheader from '@mui/material/ListSubheader'
import { Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, } from '@mui/material';
import Alert from '@mui/material/Alert'

// Define the styles for the invalid email cell

// ** Icon Imports
import Icon from '../../components/icon'

// ** Custom Components Imports
import StepperCustomDot from '../../components/mui/StepperCustomDot'
import CustomTextField from '../../components/mui/text-field'
import CustomChip from '../../components/mui/chip'
import CustomAvatar from '../../components/mui/avatar'
import ServerSideToolbar from '../../components/data-grid/ServerSideToolbar'
// import ServerSideToolbar_WithoutSearch from '../../../../../components/data-grid/ServerSideToolbar_WithoutSearch'

// ** Hook Import
import { useSettings } from '../../components/hooks/useSettings'

// ** Util Import
import { getInitials } from '../../components/utils/get-initials'

// ** Styled Component
import StepperWrapper from '../../components/styles/mui/stepper'

// ** Layout Import
import BlankLayout from '../Layout/blankLayout'
import { dev_baseUrl } from 'utils/var'

const steps = [
  {
    title: 'Map Columns'
  },
  {
    title: 'Fix Errors'
  }
]

const Step = styled(MuiStep)(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  '&:first-of-type': {
    paddingLeft: 0
  },
  '&:last-of-type': {
    paddingRight: 0
  },
  '& .MuiStepLabel-iconContainer': {
    display: 'none'
  },
  '& .step-subtitle': {
    color: `${theme.palette.text.disabled} !important`
  },
  '& + svg': {
    color: theme.palette.text.disabled
  },
  '&.Mui-completed .step-title': {
    color: theme.palette.text.disabled
  },
  '&.Mui-completed + svg': {
    color: theme.palette.primary.main
  },
  [theme.breakpoints.down('md')]: {
    padding: 0,
    ':not(:last-of-type)': {
      marginBottom: theme.spacing(6)
    }
  }
}))

// ** renders client column
const renderClient = params => {
    const { row } = params
    const stateNum = Math.floor(Math.random() * 6)
    const states = ['success', 'error', 'warning', 'info', 'primary', 'secondary']
    const color = states[stateNum]
  }
  
  const statusObj = {
    1: { title: 'current', color: 'primary' },
    2: { title: 'professional', color: 'success' },
    3: { title: 'rejected', color: 'error' },
    4: { title: 'resigned', color: 'warning' },
    5: { title: 'applied', color: 'info' }
  }
const ContactBulkImport = ({
  data = [], 
  CustomerID, msg, handleClose, open,
  fetchContactData,
  handleCloseImportDlg,
}) => {
  

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (!token) {
      navigate('/login', { state: { message: 'Please login to continue.' } }); // Redirect to login if token is not found
    } else {
      setIsLoading(false); // Set loading to false if token is found
    }
  }, [navigate]);

  const location = useLocation();
  // const fileData = location.state?.data || [];
  // const customerID = location.state?.customerID || 0;

  const fileData = data || [];
  const customerID = CustomerID || 0;

    // Get the column names from the file data
    const columnNamesFromFile = fileData.length > 0 
    ? Object.keys(fileData[0]).filter(columnName => {

        return fileData.some(row => row[columnName] && row[columnName].toString().trim() !== '');
      }) 
    : [];
    
  const predefinedFields = ['First Name', 'Last Name', 'Job Title','Email', 'Phone'];  
  
  const fieldsToRender = [...predefinedFields];

    const getDefaultValues = () => {
      const initialValues = {};
      columnNamesFromFile.forEach((columnName) => {
        initialValues[columnName] = fieldsToRender.includes(columnName)
          ? columnName
          : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase())
            ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase())
            : 'select';
      });
      return initialValues;
    };

  const [isMappingConfirmed, setIsMappingConfirmed] = useState(false);
  const [isIgnored, setIsIgnored] = useState(false);

  // ** States
  const [activeStep, setActiveStep] = useState(0)
  const [total, setTotal] = useState(0)
  const [sort, setSort] = useState('asc')
  const [searchValue, setSearchValue] = useState('')
  const [sortColumn, setSortColumn] = useState('first_name')
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 7 })
  const [mappingState, setMappingState] = useState({});
  const [selectedValues, setSelectedValues] = useState(getDefaultValues()); // Track selected dropdown values
  const [errorState, setErrorState] = useState({}); 
  const [myData, setMyData] = useState([]); 
  const [columns, setColumns] = useState([]); 
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(msg || "");
  const [errorMessages, setErrorMessages] = useState([]);
  const [openErrorListDlg, setOpenErrorListDlg] = useState(false);
  const [openSuccessListDlg, setOpenSuccessListDlg] = useState(false);
  const [successMessages, setSuccessMessages] = useState('');
  const [alertIsDismissed, setAlertIsDismissed] = useState(false);
  const [displayBanner, setDisplayBanner] = useState(true);

  // useEffect(() => {
  //   const handleBeforeUnload = (e) => {
  
  //       e.preventDefault(); 
  //       e.returnValue = ''; 
  //   };
  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage('');
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  function loadServerRows(currentPage, data) {
    return data.slice(currentPage * paginationModel.pageSize, (currentPage + 1) * paginationModel.pageSize);
  }

  const fetchTableData = useCallback(
    async (sort, q, column) => {
      let filteredData = [...myData];

      if (q) {
        filteredData = filteredData.filter(row =>
          Object.values(row).some(value =>
            value.toString().toLowerCase().includes(q.toLowerCase())
          )
        );
      }
      if (sort && column) {
        filteredData = filteredData.sort((a, b) => {
          if (a[column] < b[column]) return sort === 'asc' ? -1 : 1;
          if (a[column] > b[column]) return sort === 'asc' ? 1 : -1;
          return 0;
        });
      }
  
      setTotal(filteredData.length);
      setRows(loadServerRows(paginationModel.page, filteredData));
    },
    [paginationModel.page, paginationModel.pageSize, myData, sort, searchValue, sortColumn]

  );
  
  useEffect(() => {
    fetchTableData(sort, searchValue, sortColumn)
  }, [fetchTableData, searchValue, sort, sortColumn])

  const handleAlertDismiss = () => {
    setAlertIsDismissed(true);
  }

  const handleSortModel = newModel => {
    if (newModel.length) {
      setSort(newModel[0].sort);
      setSortColumn(newModel[0].field);
      fetchTableData(newModel[0].sort, searchValue, newModel[0].field);
    } else {
      setSort('asc');
      setSortColumn(Object.keys(myData[0])[0]); // Sort by the first key in `mappedData`
    }
  };

  const handleSearch = value => {
    setSearchValue(value);
    fetchTableData(sort, value, sortColumn);
  };

  const customerTypeOptions = [
    'Individual',
    'Business'
  ];

  // const predefinedFields = ['First Name', 'Last Name', 'Email','Company Name', 'Customer Type', 'Phone'];
  // const additionalFields = [
  //   'Mark as Lead','Tags','Time zone','City','State','Street 1','Street 2',
  //   'Floor/Level','Unit Number','Zip Code','Country'
  // ];
  // const fieldsToRender = [...predefinedFields, ...additionalFields];

  const errorColumns = [
    {
      flex: 0.25,
      minWidth: 180,
      field: 'email',      
      headerName: 'Email'
    },
    {
      flex: 0.25,
      minWidth: 180,      
      headerName: 'Reason',
      field: 'failureReason'
    }       
  ]

  const handleCloseErrorListDlg = () => {
    setOpenErrorListDlg(false);
    // goBackToAddCustomerDialog();
    // navigate(-1);
    handleClose();
    handleCloseImportDlg();
    fetchContactData();
  }

  const handleCloseSuccessListDlg = () => {

    setOpenSuccessListDlg(false);
    handleClose();
    handleCloseImportDlg();
    fetchContactData();
    // navigate(-1);
    // goBackToAddCustomerDialog();
  }

  // ** Hooks & Var
  const { settings } = useSettings()
  const smallScreen = useMediaQuery(theme => theme.breakpoints.down('md'))
  const { direction } = settings


  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  
  // // Get the column names from the file data
  // const columnNamesFromFile = fileData.length > 0 
  //   ? Object.keys(fileData[0]).filter(columnName => {
  //       // Check if this column has any non-empty value across all rows
  //       return fileData.some(row => row[columnName] && row[columnName].toString().trim() !== '');
  //     }) 
  //   : [];
  
    // const fieldsToRender = [...predefinedFields, ...additionalFields];
  
    const updateSelectedValues = () => {
      const newSelectedValues = columnNamesFromFile.reduce((acc, columnName) => {
        if (predefinedFields.includes(columnName)) {
          acc[columnName] = selectedValues[columnName] || columnName;
        }
        return acc;
      }, {});
  
      setSelectedValues(newSelectedValues);
    };
  
    useEffect(() => {
      updateSelectedValues();
    }, []);
  
  
    const handleSelectChange = (columnName) => (event) => {
      const newValue = event.target.value;
    
      setSelectedValues((prev) => {
  
        const updatedValues = { ...prev, [columnName]: newValue };

        const newErrorState = {};
        const valueCounts = {};

        Object.values(updatedValues).forEach((value) => {
          valueCounts[value] = (valueCounts[value] || 0) + 1;
        });
    
        // Identify conflicts and update the error state
        Object.keys(updatedValues).forEach((key) => {
          const value = updatedValues[key];
          if (valueCounts[value] > 1 ) {
            newErrorState[key] = `${value} has already been matched to another column`;
          } 
        });
  
        setErrorState(newErrorState);
    
        return updatedValues;
      });
    };
  
    const handleConfirmClick = (columnName) => {
  
      const selectedValue = selectedValues[columnName] || (fieldsToRender.includes(columnName) 
      ? columnName 
      : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
        ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
        : 'select');
    
      if (!selectedValue || selectedValue === 'select') {
        setMessage('Please select a valid field before confirming the mapping.');
        return;
      }
    
      setMappingState((prevState) => ({
        ...prevState,
        [columnName]: {
          ...prevState[columnName],
          confirmed: true,
          ignored: false,
          mappedValue: selectedValue || ''
        }
      }));
    };
    
    const handleIgnoreClick = (columnName) => {
      setMappingState((prevState) => ({
        ...prevState,
        [columnName]: {
          confirmed: false,
          ignored: true,
          mappedValue: '' // Clear the mapped value
        }
      }));
    };
    
    const handleEditClick = (columnName) => {
      setMappingState((prevState) => ({
        ...prevState,
        [columnName]: {
          confirmed: false,
          ignored: false,
          mappedValue: '' // Reset the mapping
        }
      }));
    }
  
    const isConfirmDisabled = (columnName) => {
      const selectedValue = selectedValues[columnName] || mappingState[columnName]?.mappedValue || (fieldsToRender.includes(columnName) 
      ? columnName 
      : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
        ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
        : 'select');
      const hasError = Boolean(
        selectedValues[columnName] && Object.values(selectedValues).filter(val => val === selectedValue).length > 1
      );
    
      // Disable if default value is 'select' or if there is an error for the field
      return selectedValue === 'select' || hasError;
    };

  // Handle Stepper
  const handleBack = () => {

    if (window.confirm("Are you sure you want to go back? Your changes might not be saved.")) {
        
      if (activeStep === 0) {
        // navigate(-1);
        // goBackToAddCustomerDialog();
        handleClose();
        handleCloseImportDlg();
      } else {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
      }
    }
  }

// const goBackToAddCustomerDialog = () => {
//   const rt = location.state?.returnTo;

//   // Prefer explicit target if provided
//   if (rt?.pathname) {
//     // Replace so user doesn't stack history
//     navigate(`${rt.pathname}${rt.search || ''}${rt.hash || ''}`, {
//       replace: true,
//       state: { ...(rt.state || {}), reopenAddCustomer: true } // ensure flag
//     });
//   } else {
//     // Fallback: one step back
//     navigate(-1);
//   }
// };

const handleNext = async (event) => {

setMessage('');

// Move to the next step
if(event.target?.innerText === 'Complete Import'){

  const updatedRows = myData.map((row) => {
    const updatedRow = { ...row };
    let hasError = false;
  
    // Validate First Name and Last Name
    const invalidNames = [null, '', 'None'];
    if (invalidNames.includes(updatedRow['First Name']) || invalidNames.includes(updatedRow['Last Name'])) {
      hasError = true;
    }
  
    // Validate email
    if (!validateEmail(updatedRow['Email'])) {
      hasError = true;
    }
  
    // Check Customer Type
    if (!customerTypeOptions.includes(updatedRow['Customer Type'])) {
      updatedRow['Customer Type'] = null;
    }
  
    if (hasError) return null;
  
    return updatedRow;
  });
  

// Filter out rows that are null (those with email errors)
const filteredRows = updatedRows.filter((row) => row !== null);

// Create the API payload
const payload = {
  rows: filteredRows,
};

const token = localStorage.getItem('jwtToken');

if (!token) {
  // If there's no token, redirect to login page
  setLoading(true);  
  navigate('/login', { state: { message: 'Session expired, please login again.' } });
  return;
}
const leadValues = ['Yes', '1', 'Y', 'y', 'True', 'true'];
// const customerTypeOptions = ['individual', 'business'];

const isValidNANPPhone = (phone) => {

  const hasInvalidCharacters = phone.match(/[^+\d\s]/);
  if (hasInvalidCharacters) {
    return false;
  }

  if (phone.startsWith('+') && !phone.startsWith('+1')) {
    return false;
  }

  const countPlus = (phone.match(/\+/g) || []).length;
  if (countPlus > 1) {
    return false;
  }

  const cleanedPhone = phone.replace(/[\+\s]/g, '');

  const normalizedPhone = cleanedPhone.startsWith('1') ? cleanedPhone : `1${cleanedPhone}`;

  if (normalizedPhone.length !== 11) {
    return false;
  }

  const areaCode = normalizedPhone.substring(1, 4);
  if (areaCode[0] === '1') {
    return false;
  }

  return true;
};

const normalizePhoneNumber = (phone) => {
  if (!phone) return null;
  const cleanedPhone = phone.replace(/\D/g, ''); // Remove non-digits
  if (cleanedPhone.startsWith('1')) {
    return cleanedPhone; // Already has country code
  }
  return `1${cleanedPhone}`; // Append country code
};

const apiPayload = payload.rows
  .filter((row) => {

    const phoneValue = row['Phone'] ? row['Phone'].toString().trim() : null;
    const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);   

    return !isInvalidPhone;
  })
  .map((row) => {
    const phoneValue = row['Phone'] ? row['Phone'].toString().trim() : null;
    const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);    

    return {    
      contactID: 0,  
      firstName: row["First Name"] || null,
      lastName: row["Last Name"] || null,
      email: row['Email'] || null,     
      phoneNumbers: [{
        phoneNo: isInvalidPhone ? null : normalizePhoneNumber(phoneValue),
        isPrimary: !isInvalidPhone,
      }],        
      jobTitle: row['Job Title'] || null,
      customerID: customerID,
      status:'active',
    };
  });

  setLoading(true);

  try {

    const response = await fetch(`${dev_baseUrl}/Contact/saveContact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(apiPayload),            
    });

    if (response.status === 400) {
      
      const errorResponse = await response.json();
      console.error('Validation Error:', errorResponse);

      const validationErrors = errorResponse.errors || {};
      const errorMessages = Object.keys(validationErrors).map((key) => {
        const errorList = validationErrors[key].join(', ');
        return `${key}: ${errorList}`;
      });

      setMessage('Validation errors occurred. Please check your input.');
      return;
    }

    if (response.status === 401) {
      navigate('/login', { state: { message: 'Session expired, please login again.' } });
      return;
    }
    
    if (!response.ok) {
      const errorMessage = `Error ${response.status}: ${response.statusText}`;
      setMessage('Failed to save Contacts data. Please try again.');
    }

    const result = await response.json();
    console.log("API Response:", result);

    if (result.isError) {
      const failureMessages = result.result
            .filter(item => item.failureReason) 
            .map(item => `${item.firstName} ${item.lastName}: ${item.failureReason}`); 

        if (failureMessages.length > 0) {
          const errorMessagesWithIds = result.result.map((row, index) => ({
            ...row,
            id: index, 
          }));
        
          setErrorMessages(errorMessagesWithIds);
          setOpenErrorListDlg(true); 
          return;
            
        }
      
    } else {
      sessionStorage.removeItem('myStep');
      setSuccessMessages('All Contacts saved successfully.');
      setOpenSuccessListDlg(true);
    }

  } catch (error) {
    console.error("Error:", error);
    setMessage('An error occurred while importing data. Please try again.');
  } finally {
    setLoading(false); // Set loader to false when request finishes
  }

} else {

  const allMappedOrIgnored = columnNamesFromFile.every(
      (columnName) => mappingState[columnName]?.confirmed || mappingState[columnName]?.ignored
    );
    
    if (!allMappedOrIgnored) {
      setMessage('Please confirm mapping or ignore all columns before continuing.');
      return;
    }

    const requiredFields = ["First Name", "Last Name", "Email", "Phone", "Job Title"];
    const isMappingComplete = requiredFields.every(field =>
      Object.values(mappingState).some(mapping => mapping.mappedValue === field && mapping.confirmed)
    );

    if (!isMappingComplete) {
      setMessage('Please map all the required fields: First Name, Last Name, Email, Phone and Job Title before proceeding.');
      return;
    }

    const mappedData = fileData.map((row, rowIndex) => {
      const mappedRow = {};
    
      // Check if the row is empty (no data in the important columns)
      const isRowEmpty = Object.values(row).every((value) => !value);
      if (isRowEmpty) {
        return null; 
      }

      for (const columnName in row) {
        if (mappingState[columnName]?.confirmed) {
          const mappedField = mappingState[columnName].mappedValue;
          mappedRow[mappedField] = row[columnName];
    
        }
      }

      return { id: rowIndex.toString(), ...mappedRow };
    }).filter(row => row !== null);

    setMyData(mappedData);
  
// ===========================================================

const rows = mappedData.map((row, index) => ({
  id: index.toString(),
  ...row,
}));
  
setRows(rows);

const columns = Object.keys(mappedData[0] || {}).map(key => {
  if (key === 'Customer Type') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <Select
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );            

          }}
          renderValue={(selected) => selected || 'None'} 
        >
          {customerTypeOptions.map(customerType => (
            <MenuItem key={customerType} value={customerType}>
              <ListItemText primary={customerType} />
            </MenuItem>
          ))}
          <MenuItem key="none" value="">
            <ListItemText primary="None" />
          </MenuItem>
        </Select>
      ),
      renderCell: (params) => {
        
        const isValidCustomerType = customerTypeOptions
          .map(option => option.toLowerCase()) 
          .includes(params.value?.toLowerCase()); 
          
        const displayValue = isValidCustomerType ? params.value : 'None';

        return (
          <Box
            sx={{
              backgroundColor: isValidCustomerType ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: '8px',
              borderRadius: '4px',
              position: 'relative',
            }}
          >
            <Tooltip
              title={isValidCustomerType ? '' : `${params.value} is not a valid value. Please select a valid value from the dropdown or this customer will be skipped`}
              placement="bottom"
              arrow
            >
              <Typography variant="body2">
                {displayValue}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    };
} else if (key === 'Mark as Lead') {
  const leadValuesDropDown = ['Yes', 'No'];
  const truthyValues = ['Y', 'y', 'Yes', 'yes', '1', true]; // Values that should map to 'Yes'
  
  return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => {
          // Check if the initial value should be 'Yes' or 'No'
          const currentValue = truthyValues.includes(params.value) ? 'Yes' : 'No';

          return (
              <Select
                  value={currentValue}
                  onChange={(event) => {
                      const isYesSelected = event.target.value === 'Yes';
                      const newValue = isYesSelected; // Set as true for 'Yes' and false for 'No'

                      // Update the grid cell value
                      params.api.setEditCellValue({ id: params.id, field: key, value: newValue }, event);

                      // Update `myData` state
                      setMyData((prevData) =>
                          prevData.map((row) =>
                              row.id === params.id ? { ...row, [key]: newValue } : row
                          )
                      );

                      // Update `rows` state directly
                      setRows((prevRows) =>
                          prevRows.map((row) =>
                              row.id === params.id ? { ...row, [key]: newValue } : row
                          )
                      );
                  }}
              >
                  {leadValuesDropDown.map((isLead) => (
                      <MenuItem key={isLead} value={isLead}>
                          <ListItemText primary={isLead} />
                      </MenuItem>
                  ))}
              </Select>
          );
      },
      renderCell: (params) => {
          // Display 'Yes' for any truthy value in the file, otherwise 'No'
          const displayLeadValue = truthyValues.includes(params.value) ? 'Yes' : 'No';

          return (
              <Box
                  sx={{
                      backgroundColor: 'transparent',
                      padding: '9px',
                      borderRadius: '4px',
                      position: 'relative',
                  }}
              >
                  <Tooltip title="">
                      <Typography variant="body2">
                          {displayLeadValue}
                      </Typography>
                  </Tooltip>
              </Box>
          );
      },
  };
} else if (key === 'Phone') {
  const isValidNANPPhone = (phone) => {
    const hasInvalidCharacters = phone.match(/[^+\d\s]/);
    if (hasInvalidCharacters) {
      return false;
    }
  
    if (phone.startsWith('+') && !phone.startsWith('+1')) {
      return false;
    }
  
    const countPlus = (phone.match(/\+/g) || []).length;
    if (countPlus > 1) {
      return false;
    }
  
    const cleanedPhone = phone.replace(/[\+\s]/g, '');
    const normalizedPhone = cleanedPhone.startsWith('1') ? cleanedPhone : `1${cleanedPhone}`;
  
    if (normalizedPhone.length !== 11) {
      return false;
    }
  
    const areaCode = normalizedPhone.substring(1, 4);
    if (areaCode[0] === '1') {
      return false;
    }
    
    return true;
  };

  return {
      field: key,
      headerName: 'Phone',
      flex: 1,
      minWidth: 150,
      editable: true,
      renderEditCell: (params) => {
          return (
              <TextField
                  value={params.value || ''}
                  onChange={(event) => {
                      const value = event.target.value;

                      params.api.setEditCellValue({ id: params.id, field: key, value }, event);
                      
                      setMyData((prevData) =>
                        prevData.map((row) =>
                          row.id === params.id ? { ...row, [key]: value } : row
                        )
                      );

                      // Update rows state
                      setRows((prevRows) =>
                          prevRows.map((row) =>
                              row.id === params.id ? { ...row, [key]: value } : row
                          )
                      );                      
                  }}
                  // error={params.value && (params.value.length !== 11 || !params.value.startsWith('1'))}
                  // helperText={params.value && (params.value.length !== 11 || !params.value.startsWith('1')) ? 'Invalid phone number' : ''}
              />
          );
      },
      renderCell: (params) => {
          const phoneValue = params.value ? String(params.value) : '';
          const isInvalidPhone = !phoneValue || !isValidNANPPhone(phoneValue);    

          return (
              <Box
                  sx={{
                      backgroundColor: isInvalidPhone ? 'rgba(227, 0, 0, 0.1)' : 'transparent',
                      padding: '9px',
                      borderRadius: '4px',
                      position: 'relative',
                  }}
              >
                  <Tooltip
                      title={isInvalidPhone ? 'This customer will be skipped. Invalid phone number.' : ''}
                      placement="bottom"
                      arrow
                  >
                      <Typography variant="body2">
                          {params.value || 'None'}
                      </Typography>
                  </Tooltip>
              </Box>
          );
      },
  };
} else if (key === 'Email') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
  
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);
  
            // Perform validation for the email
            const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
            
            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state directly, regardless of validation
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            ); 
  
            if (!isValidEmail && value !== '') {
              console.warn('Invalid email format');
            }
          }}
          variant="outlined"
          error={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.value) && params.value !== ''}
          helperText={
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.value) && params.value !== ''
              ? 'Invalid email format'
              : ''
          }
        />
      ),
      renderCell: (params) => {
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(params.value);
        params.value = params.value.length === 0 ? 'none' : params.value;
        return (
          <Box
            sx={{
              backgroundColor: isValidEmail ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: '9px',
              borderRadius: '4px',
              position: 'relative',
            }}
          >
            <Tooltip
              title={
                isValidEmail
                  ? ''
                  : 'You can start your import, but this value will be skipped. Try putting it in name@example.com'
              }
              placement="bottom"
              arrow
            >
              <Typography variant="body2">{params.value}</Typography>
            </Tooltip>
          </Box>
        );
      },
    };
  } else if (key === 'First Name') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
  
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);
  
            // Perform validation for the name
            const isValidName = value && value.length > 1 && value !=='None';
            
            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state directly, regardless of validation
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            ); 

            if (!isValidName && value !== '') {
              console.warn('Invalid name');
            }
          }}
          variant="outlined"
          error={params.value !== ''}
          helperText={
            params.value !== ''
              ? 'Invalid name'
              : ''
          }
        />
      ),
      renderCell: (params) => {
        const isValidName = params.value && params.value.length > 1 && params.value !== 'None';
        params.value = params.value.length === 0 ? 'None' : params.value;
        return (
          <Box
            sx={{
              backgroundColor: isValidName ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: '9px',
              borderRadius: '4px',
              position: 'relative',
            }}
          >
            <Tooltip
              title={
                isValidName
                  ? ''
                  : 'You can start your import, but this customer will be skipped. Try putting it a valid name'
              }
              placement="bottom"
              arrow
            >
              <Typography variant="body2">{params.value}</Typography>
            </Tooltip>
          </Box>
        );
      },
    };
  } else if (key === 'Last Name') {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
  
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);
  
            // Perform validation for the name
            const isValidName = value && value.length > 1 && value !=='None';
            
            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state directly, regardless of validation
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
            
            if (!isValidName && value !== '') {
              console.warn('Invalid name');
            }
          }}
          variant="outlined"
          error={params.value !== ''}
          helperText={
            params.value !== ''
              ? 'Invalid name'
              : ''
          }
        />
      ),
      renderCell: (params) => {
        const isValidName = params.value && params.value.length > 1 && params.value !== 'None';
        params.value = params.value.length === 0 ? 'None' : params.value;
        return (
          <Box
            sx={{
              backgroundColor: isValidName ? 'transparent' : 'rgba(227, 0, 0, 0.1)',
              padding: '9px',
              borderRadius: '4px',
              position: 'relative',
            }}
          >
            <Tooltip
              title={
                isValidName
                  ? ''
                  : 'You can start your import, but this customer will be skipped. Try putting it a valid name'
              }
              placement="bottom"
              arrow
            >
              <Typography variant="body2">{params.value}</Typography>
            </Tooltip>
          </Box>
        );
      },
    };
  }  else {
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 100,
      editable: true,
      renderEditCell: (params) => (
        <TextField
          value={params.value || ''}
          onChange={(event) => {
            const value = event.target.value;
            
            // Update the grid's internal state
            params.api.setEditCellValue({ id: params.id, field: key, value }, event);

            setMyData((prevData) =>
              prevData.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );

            // Update component's rows state
            setRows((prevRows) =>
              prevRows.map((row) =>
                row.id === params.id ? { ...row, [key]: value } : row
              )
            );
            
          }}
          variant="outlined"
        />
      ),
      renderCell: (params) => (
        <Box
          sx={{
            backgroundColor: 'transparent',
            padding: '9px',
            borderRadius: '4px',
            position: 'relative',
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.primary' }}>
            {params.value}
          </Typography>
        </Box>
      ),
    };
  }
});

const filteredColumns = columns.filter(column => column.field !== 'id');
setColumns(filteredColumns);

// ===========================================================

setActiveStep((prevActiveStep) => prevActiveStep + 1);

}

};

  const getStepContent = step => {
    switch (step) {
      case 0:
        return (
          <Fragment>
            <Grid container spacing={5} sx={{mt: 1}}>
               {displayBanner && (
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "inline-flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "rgb(35, 162, 109, 0.1)",
                        border: "1px solid",
                        borderColor: "success.main",
                        borderRadius: "12px",
                        py: 1,
                        px: 3,
                        gap: 1,
                      }}
                    >
                      <Icon icon="tabler:info-circle" />
                      <Typography
                        variant="h6"
                        fontWeight="500"
                        sx={{ ml: 2, mr: 3 }}
                      >
                        These fields are editable! -You can use your AI Assistant
                        to do this part later.
                      </Typography>
                    
                        <IconButton onClick={() => setDisplayBanner(false)}>
                          <Icon icon="tabler:x" />
                        </IconButton>
                      
                    </Box>
                  </Grid>
                )}
              { !alertIsDismissed && (
                <Grid item xs={12}>
                  <Box sx=
                    {{
                      display: 'inline-flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      backgroundColor: 'rgba(255, 159, 67, 0.16)',
                      border: '1px solid', 
                      borderColor: 'warning.main', 
                      borderRadius: '12px', 
                      py: 1,
                      px: 3,
                      gap: 2
                    }}>
                    <Icon icon="tabler:alert-triangle" />
                    <Typography variant='h6' fontWeight='500'>
                      Please ensure the First Name, Last Name, Email, Phone and Job Title fields are mapped as they are required to proceed with the next steps.
                    </Typography>
                    <IconButton onClick={handleAlertDismiss} color='warning'>
                      <Icon icon='tabler:x' />
                    </IconButton>
                  </Box>
                </Grid>
              ) }
              <Grid item xs={12} sm={4}>
                <Typography variant="h5" color='text.secondary' fontWeight='550' gutterBottom>File Source Fields</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
              <Typography variant="h5" color='text.secondary' fontWeight='550' gutterBottom>Cleri Fields</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                {/* Empty grid to align the third column (status buttons) */}
              </Grid>
            
              {/* Dropdowns Row */}
              {columnNamesFromFile.map((columnName, colIndex) => (
                <Fragment key={colIndex}>
                  <Grid item xs={12} sm={4}>
                    <CustomTextField
                      fullWidth
                      label=''
                      value={columnName}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <CustomTextField
                      fullWidth
                      select                      
                      value={selectedValues[columnName] || getDefaultValues()[columnName]}
                      // defaultValue={
                      //   fieldsToRender.includes(columnName) 
                      //     ? columnName 
                      //     : fieldsToRender.some(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
                      //       ? fieldsToRender.find(field => field.replace(/\s/g, '').toLowerCase() === columnName.replace(/\s/g, '').toLowerCase()) 
                      //       : 'select'
                      // }
                      label=''
                      onChange={handleSelectChange(columnName)} 
                      error={!!errorState[columnName]} // Apply error if duplicate is detected
                      helperText={errorState[columnName]} // Show helper text if error exists
                      disabled={mappingState[columnName]?.confirmed || mappingState[columnName]?.ignored}
                    >
                      <ListSubheader>Mandatory Fields</ListSubheader>
                      <MenuItem value='select' disabled>Select</MenuItem>
                      {predefinedFields.map((field, index) => (
                        <MenuItem key={index} value={field}>
                          {field}
                        </MenuItem>
                      ))}                     
                    </CustomTextField>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {mappingState[columnName]?.confirmed ? (
                      <Box sx={{ display: 'flex' }}>
                        <Icon>
                          <CheckCircleIcon sx={{ color: '#1FC16B', height: '17px', width: '17px', my: 'auto', mr: 2 }} />
                        </Icon>
                        <Typography sx={{ fontWeight: 'bold', color: 'success', my: 'auto', mr: 4 }}>Mapping Confirmed</Typography>
                        <Button variant='contained' color='main' onClick={() => handleEditClick(columnName)}>
                          Edit
                        </Button>
                      </Box>
                    ) : mappingState[columnName]?.ignored ? (
                      <Box sx={{ display: 'flex' }}>
                        <Typography sx={{ fontWeight: 'bold', my: 'auto', mr: 4 }}>Ignored</Typography>
                        <Button variant='contained' color='main' onClick={() => handleEditClick(columnName)}>
                          Edit
                        </Button>
                      </Box>
                    ) : (
                      <>
                        <Button
                          variant='contained'
                          sx={{ mr: 4, mb: 2 }}
                          color='main'
                          onClick={() => handleConfirmClick(columnName)}
                          disabled={isConfirmDisabled(columnName)} // Disable based on conditions
                        >
                          Confirm mapping
                        </Button>
                        <Button
                          variant='outlined'
                          color='primary'
                          sx={{ mb: 2 }}
                          onClick={() => handleIgnoreClick(columnName)}
                        >
                          Ignore this column
                        </Button>
                      </>
                    )}
                  </Grid>
                </Fragment>
              ))}
            </Grid>
          </Fragment>

        )
      case 1:
        return (
          <Fragment>          
          <Grid item xs={12} sm={12}>
            <DataGridPro
              autoHeight
              pagination
              rows={rows}
              rowCount={total}
              columns={columns}
              getRowId={(row) => row.id}              
              sortingMode="server"
              paginationMode="server"
              pageSizeOptions={[7, 10, 25, 50]}
              paginationModel={paginationModel}
              onSortModelChange={handleSortModel}
              onPaginationModelChange={setPaginationModel}
              editMode="cell"
              // onCellEditCommit={handleEditCellChangeCommitted}
              slots={{ toolbar: ServerSideToolbar }}
              slotProps={{
                baseButton: {
                  size: 'medium',
                  variant: 'tonal',
                },
                toolbar: {
                  value: searchValue,
                  
                  clearSearch: () => handleSearch(''),
                  onChange: (event) => handleSearch(event.target.value),
                  InputProps: {
                    endAdornment: searchValue ? (
                      <IconButton onClick={() => handleSearch('')}>
                        <Icon icon='tabler:x' />
                      </IconButton>
                    ) : null,
                  },
                },
              }}
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  textTransform: 'none', // This will disable the capitalization
                }
              }}
            />
          </Grid>
        </Fragment>
        )
      default:
        return 'Unknown Step'
    }
  }

  const renderContent = () => {
    
      return (
        <>
        {/* {message && (
          <Box mb={2} textAlign="center">
            <Typography variant="h6" color={message.includes('successfully') ? 'green' : 'red'}>
              {message.split('\n').map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </Typography>
          </Box>
        )}
        <form onSubmit={e => e.preventDefault()} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        {getStepContent(activeStep)}
        <Grid item xs={12} sx={{ position: 'fixed', bottom: 0, right: 0, width: '100vw', display: 'flex', justifyContent: 'flex-end', py: 4, pr: 10, backgroundColor: 'white', boxShadow: '0 -2px 5px rgba(0,0,0,0.1)' }}>        
          <Button variant='tonal' color='secondary'  onClick={handleBack} sx={{ mr: 4 }}
          // disabled={activeStep === 0}
          >
            Back
          </Button>              
          <Button variant='contained' color='main' onClick={handleNext}  disabled={loading} >
          {loading ? <CircularProgress size={24} /> : (activeStep === steps.length - 1 ? 'Complete Import' : 'Continue')}
          </Button>
        </Grid>
    </form> */}
      <Dialog
        fullWidth={true}
        maxWidth="xl"
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
          <Box sx={{ display: 'flex', flexDirection: 'column', height: '92vh' }}>
            <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
              <CardHeader 
                title={
                  <>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <StepperWrapper>
                        <Stepper
                          activeStep={activeStep}
                          connector={
                            !smallScreen ? <Icon icon={direction === 'ltr' ? 'tabler:chevron-right' : 'tabler:chevron-left'} /> : null
                          }
                        >
                          {steps.map((step, index) => (
                            <Step key={index}>
                              <StepLabel StepIconComponent={StepperCustomDot}>
                                <div>
                                  <Typography className='step-title' fontWeight={ index == activeStep ? 'bold !important' : 'normal' }>{step.title}</Typography>
                                  <Typography className='step-subtitle'>{step.subtitle}</Typography>
                                </div>
                              </StepLabel>
                            </Step>
                          ))}
                        </Stepper>
                      </StepperWrapper>
                      <Tooltip title='Close'>
                        <IconButton onClick={handleClose}>
                          <Icon icon='tabler:x' />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Divider sx={{ mt: 4 }} />
                  </>
                }
              />
              <CardContent sx={{ flexGrow: 1, overflowY: 'auto' }}>
              {message && (
                <Box mb={2} textAlign="center">
                  <Typography variant="h6" color={message.includes('successfully') ? 'green' : 'red'}>
                    {message.split('\n').map((line, index) => (
                      <div key={index}>{line}</div>
                    ))}
                  </Typography>
                </Box>
              )}
              {getStepContent(activeStep)}
              </CardContent>
              <DialogActions
                sx={{ 
                  display: "flex", 
                  justifyContent: "flex-end", 
                  padding: '20px 24px !important', 
                  boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`, 
                  zIndex: 1 }}
                className="dialog-actions-dense"
              >
                <Button variant='tonal' color='secondary'  onClick={handleBack} sx={{ mr: 4 }}
                // disabled={activeStep === 0}
                >
                  Back
                </Button>              
                <Button variant='contained' color='main' onClick={handleNext}  disabled={loading} >
                {loading ? <CircularProgress size={24} /> : (activeStep === steps.length - 1 ? 'Complete Import' : 'Continue')}
                </Button>
              </DialogActions>
            </Card>
          </Box>
      </Dialog>
    </>
      )
  }

  return (
    <BlankLayout>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '92vh' }}>
          <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
            <CardHeader 
              title={
                <>
                <StepperWrapper>
                  <Stepper
                    activeStep={activeStep}
                    connector={
                      !smallScreen ? <Icon icon={direction === 'ltr' ? 'tabler:chevron-right' : 'tabler:chevron-left'} /> : null
                    }
                  >
                    {steps.map((step, index) => (
                      <Step key={index}>
                        <StepLabel StepIconComponent={StepperCustomDot}>
                          <div>
                            <Typography className='step-title' fontWeight={ index == activeStep ? 'bold !important' : 'normal' }>{step.title}</Typography>
                            <Typography className='step-subtitle'>{step.subtitle}</Typography>
                          </div>
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </StepperWrapper>
                <Divider sx={{ mt: 4 }} />
                </>
              }
            />
            <CardContent sx={{ flexGrow: 1, overflowY: 'auto' }}>
              {renderContent()}
            </CardContent>
          </Card>
        </Box>

        {/* Error List Dialog */}      
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={openErrorListDlg}
          onClose={handleCloseErrorListDlg}
          aria-labelledby="form-dialog-title"
          sx={{
            "& .MuiDialog-paper": {
              maxWidth: '650px', // Custom maxWidth between sm and md
              width: '100%', // Ensures it’s responsive within the set max width
            },
          }}
        >
          <DialogTitle>
            <Typography variant="h4" fontWeight='bold'>Save Unsuccessful</Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <Typography variant="h6">The following customers will be skipped due to the reasons listed below.</Typography>
              </Grid>
              <Grid item xs={12}>
                <DataGridPro
                  autoHeight              
                  rows={errorMessages}
                  getRowId={(row) => row.id}
                  columns={errorColumns}           
                  sx={{
                    "& .MuiDataGrid-columnHeaderTitle": {
                      textTransform: "none",
                      fontWeight: 'bold'
                    },
                    maxWidth: '600px'
                  }}
                />
              </Grid>
            </Grid>     
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "flex-end" }}
            className="dialog-actions-dense"
          >
            <Button variant="contained" color="main" onClick={handleCloseErrorListDlg}>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        {/* Success List Dialog */}      
        <Dialog
          fullWidth={true}
          maxWidth="xs"
          open={openSuccessListDlg}
          onClose={handleCloseSuccessListDlg}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>
            <Typography variant="h4" fontWeight='bold'>Contacts Import Success</Typography>
          </DialogTitle>
          <DialogContent>
            <Fragment>          
              {successMessages}
            </Fragment>
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", justifyContent: "flex-end" }}
            className="dialog-actions-dense"
          >
            <Button variant="contained" color="main" onClick={handleCloseSuccessListDlg}>
              OK
            </Button>
          </DialogActions>
        </Dialog>

    </BlankLayout>
  )
}

export default ContactBulkImport